import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'site-tree',
  templateUrl: './site-tree.component.html',
  styleUrl: './site-tree.component.css',
  host: { 'class': 'page-container' },
  standalone: false
})
export class SiteTreeComponent {
  siteId: number | null = null;
  availableViews: string[] = ['Location tree', 'Product tree'];
  selectedView: string = this.availableViews[0];

  constructor(private route: ActivatedRoute) {
    this.route.params.subscribe(() => {
      const idParam = this.route.snapshot.paramMap.get('id') as unknown;
      const id = idParam as number;
      if (id == null)
        return;

      this.siteId = id;
    });
  }
}
